<template>
  <v-main class="mt-12 mt-md-16">
    <v-row>
      <v-col cols="12" md="10" offset-md="1">
        <div class="main-header text-left pl-6 pl-md-1 mb-4">{{$t('confirmation.main_header')}}</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="10" offset-md="1">
        <div class="main-subheader text-left pl-6 pl-md-1 mb-6" v-html="$t('confirmation.main_subheader')"></div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="10" offset-md="1">
        <div v-if="loading">
          <v-progress-circular
            indeterminate
            color="primary"
            class="progress"
          ></v-progress-circular>
        </div>
        <div v-else class="mb-16">
          <div v-for="(item, index) in Object.keys(cart.items).filter(item => cart.items[item].acceptance_id == null)" :key="item">
            <div v-if="!index">
              <compare-to-donor-component 
                :show_in_dialog="false"
                :donor_phenotype="cart.items[item]._source"
                :donor_nickname="cart.items[item]._source.donor_process.donor_nickname"
                :donor_product_key="item"
                :donor_material_type="cart.items[item]._source.material.type"
                :user_id=null
                :oidc_user="oidcUser"
                action="accept">
              </compare-to-donor-component>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
import axios from "axios"
import { onMounted, ref, computed } from 'vue'
import { useStore } from 'vuex'
import CompareToDonorComponent from '../components/CompareToDonorComponent.vue'

export default {
  components: {
    CompareToDonorComponent
  },
  setup() {
    const store = useStore()
    let loading = ref(false)
    let cart = ref({
      items: store.getters['cartModule/getItems']
    })

    const getCart = () => {

      return new Promise((resolve, reject) => {
        axios.get('/api/cart')
        .then((response) => {
          cart.value = response.data;
          let items = [];
          
          items = Object.keys(cart.value.items).map(e => {
            if (store.getters['reservationModule/getChecked'].includes(e)) {
              return new Promise((resolve, reject) => {
                axios.get(`/api/donor/${e}/${cart.value.items[e].material_type}/data`)
                .then((response) => {
                  cart.value.items[e] = {
                    ...cart.value.items[e],
                    checked: cart.value.items[e].is_available,
                    acceptance_id: null,
                    ...response.data
                  }
                  resolve(response);
                })
                .catch(error => {
                  console.error(error);
                  reject(error);
                })
              })
            } else {
              delete cart.value.items[e]
            }
          });

          Promise.all(items)
          .then((response) => {
            resolve(response);
          })
          .catch(error => {
            console.error(error);
            reject(error);
          })
          .finally(() => {
            store.dispatch('cartModule/setItems', cart.value.items)
            .then(() => {
              loading.value = false
            })
          })

        })
        .catch(error => {
          console.error(error);
          reject(error);
        })
      });
    }

    onMounted(() => {
      loading.value = true
      axios.delete(`/api/donor/phenotype_acceptance`).then(() => {
        getCart()
      })
    })

    return {
      loading,
      cart,
      oidcUser: computed(() => store.getters['oidcStore/oidcUser']) 
    }
  }
}

</script>

<style lang="scss" scoped>
  .main-header {
    @include nsb-gentium-bold;
    font-size: 28px;
    line-height: 36px;
  }
  .main-subheader {
    font-size: 12px;
    line-height: 20px;
  }

  @media (min-width: 960px) {
    .main-header {
      font-size: 40px;
      line-height: 52px;
    }
    .main-subheader {
      font-size: 14px;
      line-height: 22px;
    }
  }
</style>